import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/order/audit/settle/save',
    data: from,
    method: 'post'
  })

export const pay = (from) => axios.request({
  url: '/order/audit/settle/pay',
  data: from,
  method: 'post'
})
export const batchPay = (from) => axios.request({
  url: '/order/audit/settle/batchPay',
  data: from,
  method: 'post'
})

export const findByCid = (channelId, settleType, serviceType) => axios.request({
  url: '/order/audit/set/findByCid',
  params: { channelId, settleType, serviceType },
  method: 'get'
})